import classnames from "classnames";
import { type Ref, type InputHTMLAttributes } from "react";

export interface PlainInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export default function PlainInput({ invalid, ...props }: PlainInputProps) {
  const className = classnames(
    "relative block w-full appearance-none rounded-md border border-solid bg-white bg-clip-padding px-3 py-2 font-normal leading-normal text-black transition focus:shadow focus:outline-0 disabled:bg-gray-300 dark:bg-neutral-800 dark:text-white dark:disabled:bg-neutral-700",
    {
      "border-red-300 shadow-rose-700/25": invalid,
      "border-zinc-200 dark:border-zinc-600 focus:border-blue-300": !invalid,
    },
  );
  return <input {...props} className={className} />;
}
